import { handleActions } from "redux-actions";

const nestedSort = (prop1, prop2 = null, direction = "asc") => (e1, e2) => {
  const a = prop2 ? e1[prop1][prop2] : e1[prop1],
    b = prop2 ? e2[prop1][prop2] : e2[prop1],
    sortOrder = direction === "asc" ? 1 : -1;
  return a < b ? -sortOrder : a > b ? sortOrder : 0;
};

function sortProductGroups(productGroups) {
  if (!productGroups) {
    return null;
  } else {
    return productGroups.map((group) => ({
      ...group,
      products: group.products.sort(
        nestedSort("product_group_maps", "product_index")
      ),
    }));
  }
}

const initState = {
  isFetchingProductGroups: false,
  isCreatingProductGroup: false,
  isCreatedProductGroup: false,
  isUpdatingProductGroup: false,
  isUpdatedProductGroup: false,
  isDeletingProductGroup: false,
  isDeletedProductGroup: false,
  isUpdatingProductLink: false,
  isUpdatedProductLink: false,
  productGroups: null,
};

const reducer = handleActions(
  {
    REQUESTED_PRODUCT_GROUPS: (state) => ({
      ...state,
      isFetchingProductGroups: true,
      isCreatedProductGroup: false,
      isUpdatedProductGroup: false,
      isDeletedProductGroup: false,
    }),
    RECEIVED_PRODUCT_GROUPS: (state, action) => {
      const newState = {
        ...state,
        isFetchingProductGroups: false,
        isCreatedProductGroup: false,
        isUpdatedProductGroup: false,
        isDeletedProductGroup: false,
        productGroups: sortProductGroups(action.payload.productGroups),
      };
      return newState;
    },
    REQUESTED_CREATE_PRODUCT_GROUP: (state) => {
      const newState = {
        ...state,
        isCreatingProductGroup: true,
        isCreatedProductGroup: false,
      };
      return newState;
    },
    RECEIVED_CREATE_PRODUCT_GROUP: (state, action) => {
      const newState = {
        ...state,
        isCreatingProductGroup: false,
        isCreatedProductGroup: true,
        productGroups: sortProductGroups(action.payload.productGroups),
      };
      return newState;
    },
    REQUESTED_UPDATE_PRODUCT_GROUP: (state) => {
      const newState = {
        ...state,
        isUpdatingProductGroup: true,
        isFetchingProductGroups: true,
        isUpdatedProductGroup: false,
      };
      return newState;
    },
    RECEIVED_UPDATE_PRODUCT_GROUP: (state, action) => {
      const newState = {
        ...state,
        isUpdatingProductGroup: false,
        isFetchingProductGroups: false,
        isUpdatedProductGroup: true,
        productGroups: sortProductGroups(action.payload.productGroups),
      };
      return newState;
    },
    REQUESTED_DELETE_PRODUCT_GROUP: (state) => {
      const newState = {
        ...state,
        isDeletingProductGroup: true,
        isDeletedProductGroup: false,
      };
      return newState;
    },
    RECEIVED_DELETE_PRODUCT_GROUP: (state, action) => {
      const newState = {
        ...state,
        isDeletingProductGroup: false,
        isDeletedProductGroup: true,
        productGroups: sortProductGroups(action.payload.productGroups),
      };
      return newState;
    },
    REQUESTED_UPDATE_PRODUCT_LINK: (state) => {
      const newState = {
        ...state,
        isUpdatingProductLink: true,
        isFetchingProductGroups: true,
        isUpdatedProductLink: false,
      };
      return newState;
    },
    RECEIVED_UPDATE_PRODUCT_LINK: (state, action) => {
      const newState = {
        ...state,
        isUpdatingProductLink: false,
        isFetchingProductGroups: false,
        isUpdatedProductLink: true,
        productGroups: sortProductGroups(action.payload.productGroups),
      };
      return newState;
    },
  },
  initState
);

export default reducer;
